import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import CallMeDialog from './register';
import img1 from './images/kits/k1.jpeg';
import img2 from './images/kits/k2.jpeg';
import img3 from './images/kits/k3.jpeg';
import kit2 from './images/kitt2.jpg';
import { useNavigate } from 'react-router';
function Kit1()
{
  let nav=useNavigate();
  return (    
    <div className="min-h-screen">
      <Header />      
      <main>        
        {/* Intro Section */}
        <section className="py-24 bg-black">
          <div className="container mx-auto px-4 text-center">
            <div className="max-w-4xl mx-auto">
              <i className="fas fa-crown text-gold text-4xl mb-8"></i>
              <h2 className="text-4xl md:text-5xl font-serif text-white mb-8 leading-tight">
                Our Best Selling Premium Product
              </h2>              
              <div>                
                <div style={{display:'flex'}}>
                    <img src={img3} width="50%"/>                
                    <img src={img2} width="50%"/>                
                </div>
                <h2 className="text-3xl md:text-2xl text-white mb-8 mt-6 leading-tight">
                    Price Only &#8377; 15,500/-<br/>
                    Special Introductory Price* (100% Guarantee, 100% Ayurvedic)<br/>
                    <input type="button" onClick={(event)=>{nav("/orderkit/1")}} value="Buy Now" style={{width:'250px',marginTop:'20px', borderRadius:'20px'}} className='bg-gold text-black font-bold tracking-widest py-3 hover:bg-white transition-all' />
                </h2>
              </div>  
              <div>                
                <div style={{display:'flex'}}>
                    <img src={kit2} width="100%"/>                                    
                </div>
                <h2 className="text-3xl md:text-2xl text-white mb-8 mt-6 leading-tight">
                    Price Only &#8377; 10,500/-<br/>
                    Special Price* (100% Guarantee, 100% Ayurvedic)<br/>
                    <input type="button" onClick={(event)=>{nav("/orderkit/2")}} value="Buy Now" style={{width:'250px',marginTop:'20px', borderRadius:'20px'}} className='bg-gold text-black font-bold tracking-widest py-3 hover:bg-white transition-all' />
                </h2>
              </div>  
            </div>
          </div>
        </section>        
      </main>
      <Footer />
    </div>
  );  
}

export default Kit1;
